import { useTranslation } from "react-i18next";
import type { OrgGovernanceRollup } from "@/types/executive";

interface ExecNarrativeProps {
  rollup: OrgGovernanceRollup;
}

export function ExecNarrative({ rollup }: ExecNarrativeProps) {
  const { t } = useTranslation();

  const { score, pending_count } = rollup;

  const toneKey =
    score === null
      ? "executive.narrative.noData"
      : score >= 70
        ? "executive.narrative.good"
        : score >= 50
          ? "executive.narrative.warn"
          : "executive.narrative.bad";

  const pendingNote =
    pending_count > 0
      ? t("executive.narrative.pendingNote", { count: pending_count })
      : "";

  return (
    <div role="region" aria-label={t("executive.narrative.region")} className="rounded-lg border bg-muted/30 p-4 space-y-1">
      <p className="text-sm text-foreground">{t(toneKey)}</p>
      {pendingNote && (
        <p className="text-xs text-muted-foreground">{pendingNote}</p>
      )}
    </div>
  );
}
